// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1aanv","productName":"Table_productName__37K7_"};